/**
 * Created by vlad on 11.12.18.
 */

const DirtyHoneyTileView = cc.Node.extend({
    ...BaseTileView,
    ctor: function (tile) {
        this._super();

        this.setAnchorPoint(0.5, 0.5);
        this.initialize(tile);

        const image = this.image = new cc.Sprite(bundles.dirty_honey.frames.dirty_honey_tile);
        this.addChild(image);
        image.setAlignment(this.width / 2, this.height / 2);
        if (tile.x < 0) {
            image.setScale(0.8);
        }
    },
    initialize: function (tile) {
        BaseTileView.initialize.call(this, tile);

        this.tile.onCreateNew = this.animateCreateNew.bind(this);
    },
    animateCreateNew: function () {
        this.setScale(1);
        this.image.visible = false;

        BaseAnimation.runAnimate(this, bundles.dirty_honey.jsons.dirty_honey_json, "under_on", () => {
            this.image.visible = true;
        }, this.image);

        cleverapps.effects.fire(cleverapps.styles.DirtyHoneyTileView.growUpEffect);
    },
    startExploding: function () {
        this.stopAllActions();
        BaseAnimation.runAnimate(this, bundles.dirty_honey.jsons.dirty_honey_json, "under_off", this.image);
        cleverapps.effects.fire(cleverapps.styles.DirtyHoneyTileView.dieEffect);
    }
});

cleverapps.styles.DirtyHoneyTileView = {
    growUpEffect: "match3.dirty_honey.create",
    dieEffect: "match3.element.die"
};